/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-title-column[_ngcontent-%COMP%]{white-space:normal!important;text-align:start!important;line-height:20px!important;width:1%!important}.table-value[_ngcontent-%COMP%]{min-width:5rem!important;text-align:end!important}.company-label[_ngcontent-%COMP%]{font-size:1rem!important}.card-content[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important;font-size:14px!important}"];
export { styles as styles };
